import React from 'react';
import ApiUtils from './ApiUtils';
import ArratDataUtils from './ArratDataUtils';
import TimeUtils from './TimeUtils';

/*
 * 處理專案相關的資料
 * */
export default class ProjectUtils {
  /***
   * 要從無到有取得 EditingProjectInfo
   */
  static getEditingProjectInfo(_listData) {
    let listData = [];
    listData = _listData;

    let listView = [];

    //要累計所有project
    let projectObjArray = []; //主要的專案內容資料
    let projectArray = [];
    let projectIDArray = [];

    if (listData.length == 0) {
      return { projectArray, listView };
    }

    //過濾掉null
    listData = listData.filter((data) => data['Project'] !== null);

    //排序
    listData.sort(function (a, b) {
      return a.Project.fId - b.Project.fId;
    });

    //一般用戶
    listData.map((request) => {
      const { Project, suL, tarL, video, worker } = request;
      if (Project !== null) {
        const { fId } = Project;

        if (ArratDataUtils.containsObject(fId, projectIDArray) === false) {
          projectIDArray.push(fId);
          projectObjArray.push({
            Project,
            suL,
            tarL,
            video,
            worker,
          });
        }
      }
    });

    projectIDArray.map((request, index) => {
      //主要的專案資料
      let mainProjectData = {
        Project: null,
        Step: null,
      };
      mainProjectData['Project'] = projectObjArray[index];

      if (mainProjectData['Project'] !== null) {
        //let detielaArray = listData.filter(data=>data["Project"]["fId"] === request);
        let detielaArray = [];
        listData.forEach((data) => {
          if (data['Project'] !== null) {
            if (data['Project']['fId'] === request) {
              detielaArray.push(data);
            }
          }
        });
        detielaArray.sort(function (a, b) {
          return a.Project.fId - b.Project.fId;
        });

        //專案搭配上詳細資料列表
        let newProjectAddList = {};
        newProjectAddList = mainProjectData;

        //newProjectAddList['Step'] = listData.filter(data=>data["Project"]["fId"] === request);
        let StepArray = [];
        listData.forEach((data) => {
          if (data['Project'] !== null) {
            if (data['Project']['fId'] === request) {
              StepArray.push(data);
            }
          }
        });
        StepArray.sort(function (a, b) {
          return a.projectDetial.fId - b.projectDetial.fId;
        });

        newProjectAddList['Step'] = StepArray;

        projectArray.push(mainProjectData);
      }
    });

    projectArray.reverse();

    //組合完後的projectArray
    projectArray.map((pData) => {
      const { Project, Step } = pData;
      const { suL, tarL, video } = Project;

      let VideoUrl = video !== null ? video.fURL : '';
      let ProjectInfo = Project['Project'];

      let DeliveryDate = TimeUtils.getDateFromDateString(
        ProjectInfo['fDeliveryDate']
      );

      listView.push({
        Id: Project['Project']['fId'],
        SubType: Project['Project']['tSubType'],
        ProjectTitle: Project['Project']['fProjectTitle'],
        SourceLanguage: suL !== null ? suL.fName : '',
        TargetLanguage: tarL !== null ? tarL.fName : '',
        VideoUrl: VideoUrl,
        DeliveryDate: DeliveryDate,
        fDueDate: ProjectInfo['fDeliveryDate'],
        Season: Project['Project']['fSeason'],
        Episode: Project['Project']['fEpisodeTitleNum'],
        Step: Step,
        worker: '',
        Project: Project['Project'],
      });
    });

    return { projectArray, listView };
  }

  /***
   * 儲存
   */

  static async sentGetProjectDetial(fUserId) {
    
    const resData = await ApiUtils.post_sql(`${ApiUtils.post_GetOrderDetial}`, {
      fUserId: parseFloat(fUserId),
    });
    return resData;

    // const pCount = 30;
    // const pList = await ApiUtils.post_sql(
    //   `${ApiUtils.get_GetProjectListlByCount}`,
    //   {
    //     listCount: parseFloat(pCount),
    //   }
    // );

    // let resData = [];
    // const pAllData_ = await ApiUtils.post_sql(
    //   `${ApiUtils.get_GetProjectDetialByPid}`,
    //   {
    //     projectDetialiD: pList[].fId,
    //   }
    // );
    // resData.push(pAllData_);
    // return resData;
    // let index =0;
    // while (resData.length < pCount){
    //   const pAllData = await ApiUtils.post_sql(
    //     `${ApiUtils.get_GetProjectDetialByPid}`,
    //     {
    //       projectDetialiD: pList[index].fId,
    //     }
    //   );
    //   index +=1;
    //   resData.push(pAllData);
    //   if (index === (pCount-1)) {
    //     return resData;
    //   }
    // }
    // await pList.map(async (pObj, index) => {
    //   const pAllData = await ApiUtils.post_sql(
    //     `${ApiUtils.get_GetProjectDetialByPid}`,
    //     {
    //       projectDetialiD: pObj.fId,
    //     }
    //   );
    //   resData.push(pAllData);
    //   if (resData.length === pCount) {
    //     return resData;
    //   }
    // });

    //  const DetialData_0 =  await ApiUtils.post_sql(`${ApiUtils.get_GetProjectDetialByPid}`, {
    //     projectDetialiD: pList[0].
    //     fId,
    //   })
    //   resData.push(DetialData_0);
  }

  /**
   * 取全資料
   */
  static async sentGetAllProjectDetial(fUserId) {
    // const resData1 = await ApiUtils.get_sql(`${ApiUtils.get_GetAllProjectDetial}?fUserId=${parseFloat(fUserId)}`);
    // console.log('sentGetAllProjectDetial 1 ' + resData1);

    const resData = await ApiUtils.post_sql(
      `${ApiUtils.post_GetAllProjectDetial}`,
      {
        fUserId: parseFloat(fUserId),
      }
    );
    // console.log("sentGetAllProjectDetial 2 " + resData);

    return resData;
  }

  static getProjectTitle(projectIndex) {
    const projectListDataString = localStorage.getItem('projectListData');
    let projectListData = JSON.parse(projectListDataString);
    if (projectListData !== null) {
      const projectData = projectListData[projectIndex];

      const { Project } = projectData;
      return Project.fProjectTitle;
    }
    return '';
  }

  //取得專案標題
  static getEditingProjectTitle() {
    let EditingProjectTitle = '';
    if (window.EditingProjectInfo) {
      const EditingProjectInfoData = window.EditingProjectInfo;
      const InfoJsonData = JSON.parse(EditingProjectInfoData);
      const { Episode, Season, ProjectTitle, Step } = InfoJsonData;

      //取得步驟語系資料
      const { suL, tarL } = Step[0];
      //
      EditingProjectTitle = `${ProjectTitle}_${Season}_${Episode}_${suL.fCode}_${tarL.fCode}`;
    }
    return EditingProjectTitle;
  }
}



// WEBPACK FOOTER //
// ./src/helper/ProjectUtils.js